import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid-1" }
const _hoisted_2 = { class: "flex w-full space-x-4" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "w-full space-x-2 flex justify-end" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger-light text-end text-sm"
}

import { RepairOrderResource } from '@shared/resources/repair-order';
import { OrderCreateUpdateDto } from '../dto';
import { useSelectClientDataManager, SingleSelect } from '@ui-kit/inputs/select';
import { useRepairTypesStore } from '../../../../../../stores/dictionary/repair-types';
import { Table, TableClientDataManager, TableComponentParams } from '@ui-kit/table';
import { computed } from 'vue';
import { RepairTypeResource } from '@shared/resources/repair-type';
import { useI18n } from 'vue-i18n';
import Label from '@ui-kit/label/Label.vue';
import ValidationKeyObserver from '@components/validation/ValidationKeyObserver.vue';
import SingleLine from '@ui-kit/inputs/single-line/SingleLine.vue';
import Button from '@ui-kit/controls/button/Button.vue';
import { useModalsStore } from '../../../../../../stores/modals';
import ModalManageRepairType from '../../../../dictionary/repair-types/modals/ModalManageRepairType.vue';
import { coinsFormat } from '@shared/helpers/data-converters/number-converters';
import { countItemPrice } from '@shared/helpers/sum';

interface Props {
  data: RepairOrderResource;
  formData: OrderCreateUpdateDto;
}
interface Emits {
  (type: 'update', event: OrderCreateUpdateDto['repair_items']): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TabRepairs',
  props: {
    data: null,
    formData: null
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
  (type: 'update', event: OrderCreateUpdateDto['repair_items']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data: RepairOrderResource;
  formData: OrderCreateUpdateDto;
}

const { t } = useI18n();
const repairTypesStore = useRepairTypesStore();
const modalsStore = useModalsStore();





function createRepair() {
  modalsStore.addModal({
    component: ModalManageRepairType,
    events: {
      save(repair: RepairTypeResource) {
        chooseRepair(repair);
      }
    }
  })
}
const repairsSelectManager = useSelectClientDataManager({
  data: computed(() => repairTypesStore.data),
  searchBy: ['name'],
});
function chooseRepair(repair: RepairTypeResource) {
  const existed = props.formData.repair_items.find(({ id }) => id === repair.id);
  if (existed) {
    emit('update', props.formData.repair_items.map((current) => ({
      ...current,
      qty: current.id === repair.id ? String((Number(current.qty) || 0) + 1) : current.qty,
    })));
  } else {
    emit('update', [
      {
        id: repair.id,
        qty: '1',
        price: '',
      },
      ...props.formData.repair_items,
    ]);
  }
}
function updateRepairPrice(id: number, price?: string) {
  emit('update', props.formData.repair_items.map((current) => ({
    ...current,
    price: current.id === id ? price : current.price,
  })));
}
function updateRepairQty(id: number, qty?: string) {
  emit('update', props.formData.repair_items.map((current) => ({
    ...current,
    qty: current.id === id ? qty : current.qty,
  })));
}
function removeRepair(id: number) {
  emit('update', props.formData.repair_items.filter((repair) => repair.id !== id));
}

const selectedRepairs = computed(() => {
  return props.formData.repair_items.map((repair, index) => {
    const repairData = repairTypesStore.data.find(({id}) => id === repair.id);
    return {
      ...repair,
      index,
      repair: repairData,
    };
  });
});
const repairsTableManager = new TableClientDataManager({
  providedData: selectedRepairs,
});
const repairsTableParams = computed<TableComponentParams>(() => {
  return {
    searchable: false,
    columns: [
      {
        name: 'repair.name',
        data: 'repair.name',
        title: t('fields.name'),
        sortable: true,
        responsiveOrder: 1,
      },
      {
        name: 'qty',
        title: t('fields.qty'),
        width: 120,
      },
      {
        name: 'price',
        title: t('fields.price_local'),
        width: 120,
        cellClasses: 'text-gray-600 text-sm',
      },
      {
        name: 'result_price',
        title: t('pages.orders.result-price'),
        data: (row) => {
          return coinsFormat(countItemPrice({
            ...row,
            qty: 1,
          }, {
            adjustment: props.formData.adjustment,
          }));
        },
        width: 160,
        hidden: props.formData.adjustment === 0
      },
      {
        name: 'sum',
        title: t('fields.sum_local'),
        data: (row) => {
          return coinsFormat(countItemPrice(row, {
            adjustment: props.formData.adjustment,
          }));
        },
        width: 120,
        hidden: props.formData.adjustment === 0
      },
      {
        name: 'actions',
        title: '',
        width: 150,
        responsiveOrder: 2,
      },
    ]
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Label, {
      label: _ctx.$t('pages.orders.select-add-repair')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(SingleSelect), {
            class: "flex-grow",
            "data-manager": _unref(repairsSelectManager),
            "select-option-text": _ctx.$t('pages.orders.select-repair'),
            "onUpdate:modelValue": chooseRepair
          }, null, 8, ["data-manager", "select-option-text"]),
          _createVNode(Button, {
            onClick: createRepair,
            "button-type": "outline"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.new')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(_unref(Table), {
      params: _unref(repairsTableParams),
      "data-manager": _unref(repairsTableManager)
    }, {
      "cell-qty": _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ValidationKeyObserver, {
            keys: ['repair_items', row.index, 'qty']
          }, {
            default: _withCtx(({ firstErrorMessage }) => [
              _createVNode(SingleLine, {
                "model-value": row.qty,
                "onUpdate:modelValue": ($event: any) => (updateRepairQty(row.id, $event)),
                type: "number",
                errors: firstErrorMessage,
                flat: "",
                small: "",
                class: "table-input"
              }, null, 8, ["model-value", "onUpdate:modelValue", "errors"])
            ]),
            _: 2
          }, 1032, ["keys"])
        ])
      ]),
      "cell-price": _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ValidationKeyObserver, {
            keys: ['repair_items', row.index, 'price']
          }, {
            default: _withCtx(({ firstErrorMessage }) => [
              _createVNode(SingleLine, {
                "model-value": row.price,
                "onUpdate:modelValue": ($event: any) => (updateRepairPrice(row.id, $event)),
                type: "number",
                errors: firstErrorMessage,
                flat: "",
                small: "",
                class: "table-input"
              }, null, 8, ["model-value", "onUpdate:modelValue", "errors"])
            ]),
            _: 2
          }, 1032, ["keys"])
        ])
      ]),
      "cell-actions": _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Button, {
            onClick: ($event: any) => (removeRepair(row.id)),
            color: "danger"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.delete')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["params", "data-manager"]),
    _createVNode(ValidationKeyObserver, { keys: "repair_items" }, {
      default: _withCtx(({ firstErrorMessage }) => [
        firstErrorMessage
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(firstErrorMessage) + "! ", 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})